import React, { useEffect } from "react";

import { useAnalyticsIdentify } from "@common/analytics/useAnalyticsIdentify";
import { useFullStoryIdentify } from "@common/analytics/useFullStoryIdentify";
import { useRouteChangeTracker } from "@main/router/util/useRouteChangeTracker";
import { Outlet } from "react-router";

import { useWorkspacesAPI } from "../consumers/useWorkspacesAPI";

export function RootLayoutView() {
  const { fetchWorkspacesAndDispatch } = useWorkspacesAPI();

  useRouteChangeTracker();
  useAnalyticsIdentify();
  useFullStoryIdentify();

  useEffect(() => {
    fetchWorkspacesAndDispatch();
  }, [fetchWorkspacesAndDispatch]);

  return <Outlet />;
}
